module.exports = __webpack_public_path__ + "servicesCover.91ce48e860d235cde23c.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/coverPicks/servicesCover.jpg
// module id = ../../../../../src/assets/coverPicks/servicesCover.jpg
// module chunks = 0